import { and, not } from '@ember/object/computed';
import Em from 'ember';
export default Em.Component.extend({
  classNameBindings: ['showDeleteIcon:composer-attachment-can-delete'],
  isNotTyping: not('isTyping'),
  isNotReadOnly: not('isReadOnly'),
  canShowDeleteIcon: and('isNotTyping', 'isNotReadOnly'),
  mouseEnter() {
    if (this.get('canShowDeleteIcon')) {
      this.set('showDeleteIcon', true);
    }
  },
  mouseLeave() {
    this.set('showDeleteIcon', false);
  },
  actions: {
    retry(id) {
      this.get('composerState').retryAttachmentById(id);
    },
    delete(id) {
      this.get('composerState').deleteAttachmentById(id);
    }
  }
});